import React from 'react';
import './style.css';
import NavBar from './NavBar';
import myPhoto from './images/my-photo.png';
import Resume from './images/Vidhi_Sinha_Resume.pdf';

function FeaturedProjectCard({ title, description, tech, link }) {
  return (
    <div className="project-card">
      <h3>{title}</h3>
      <p className="muted">{description}</p>
      <div className="project-tech">
        {tech.map((t, i) => <span key={i}>{t}</span>)}
      </div>
      {link && (
        <a href={link} target="_blank" rel="noopener noreferrer" className="project-link">
          View Project →
        </a>
      )}
    </div>
  );
}

export default function Home() {
  return (
    <div className="page-root">
      <NavBar />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="hero" id="home">
        <div className="hero-arc" aria-hidden="true" />
        <div className="hero-blob" aria-hidden="true" />

        <div className="hero-left">
          <h1 className="hero-title">VIDHI SINHA</h1>
          <p className="hero-sub">
            Senior Analytics Consultant driving data-backed business
            decisions through forecasting, analytics, and executive insights.
          </p>
          <p className="hero-detail">
            7+ years of experience delivering Python, SQL, and Power BI solutions
            across Oil &amp; Gas, Financial Services, and Research &amp; Insights domains.
          </p>
          <div className="hero-dots" aria-hidden="true">
            <span /><span /><span />
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-photo-frame">
            <img src={myPhoto} alt="Vidhi Sinha" />
          </div>
        </div>
      </section>

      {/* ── MAIN CONTENT ─────────────────────────────────────── */}
      <div className="scroll-container">

        {/* FEATURED PROJECT */}
        <section id="featured-projects" className="glass-compartment">
          <h2 className="section-header">Featured Project</h2>
          <div className="featured-project-grid">
            <FeaturedProjectCard
              title="Habit Engine — Predictive Behavioral Analytics"
              description="A personal analytics exploration of user adherence prediction and behavioral nudge optimisation using probabilistic forecasting. Models user habit streaks, predicts drop-off risk, and simulates nudge interventions to improve long-term engagement."
              tech={['Adherence Prediction (Logistic Regression)', 'Burnout Risk Assessment (Cox Proportional Hazards Survival Model)', 'Behavioral Anomaly Detection (Isolation Forest)']}
              link="https://github.com/VidhiSinha27/Habit-Engine"
            />
          </div>
        </section>

        {/* WORK EXPERIENCE */}
        <section id="experience" className="glass-compartment">
          <h2 className="section-header">Work Experience</h2>
          <div className="experience-timeline">
            <div className="exp-item">
              <div className="exp-header">
                <h3>Assistant Manager, Research &amp; Insights</h3>
                <span className="exp-company">Deloitte USI</span>
              </div>
              <p className="exp-date">July 2025 – May 2026</p>
              <p className="muted">Managed end-to-end execution of survey analytics engagements, leveraging Power BI and Excel to automate dashboards and improve stakeholder reporting efficiency. Collaborated with econometrics unit to build sector sensitivity models and time-series forecasts, enabling data-driven market assessments across multiple industries.</p>
            </div>
            <div className="exp-item">
              <div className="exp-header">
                <h3>Lead Analyst, Data &amp; Analytics</h3>
                <span className="exp-company">Infosys</span>
              </div>
              <p className="exp-date">February 2022 – July 2025</p>
              <p className="muted">Led analytics delivery for two Oil & Gas projects supporting 50+ business users, translating requirements into Python-based solutions that reduced manual effort by 85% and accelerated reporting turnaround by 40%.</p>
            </div>
            <div className="exp-item">
              <div className="exp-header">
                <h3>Systems Engineer</h3>
                <span className="exp-company">Tata Consultancy Services</span>
              </div>
              <p className="exp-date">July 2018 – January 2022</p>
              <p className="muted">Design and implementation of analytics solutions across HR domains, predictive churn modeling, and reporting automation. Collaborated with business stakeholders to translate requirements into scalable solutions, leveraging Python, Excel, and Power Query to improve operational efficiency, enhance customer insights, and accelerate reporting cycles.</p>
            </div>
          </div>
        </section>

        {/* SKILLS */}
        <section id="skills" className="glass-compartment">
          <h2 className="section-header">Skills</h2>
          <div className="skills-grid">
            <div className="skill-group">
              <strong>Analytics &amp; Forecasting</strong>
              <p className="muted">Time-series, scenario planning, demand &amp; revenue forecasting, statistical modeling</p>
            </div>
            <div className="skill-group">
              <strong>Python &amp; SQL</strong>
              <p className="muted">Production-ready pipelines, data engineering, statistical programming, CI/CD</p>
            </div>
            <div className="skill-group">
              <strong>Power BI &amp; Visualisation</strong>
              <p className="muted">Executive dashboards, KPI frameworks, storytelling, Power Apps</p>
            </div>
            <div className="skill-group">
              <strong>Decision Intelligence</strong>
              <p className="muted">Scenario engines, trade-off analyses, stakeholder frameworks</p>
            </div>
            <div className="skill-group">
              <strong>Statistical Modeling</strong>
              <p className="muted">Predictive Modeling,Logistic Regression, Time Series prediction, Vector AutoRegression, OLS regression, Descriptive statistics, Machine Learning</p>
            </div>
            <div className="skill-group">
              <strong>Stakeholder Management</strong>
              <p className="muted">Executive communication, product prioritisation, cross-functional delivery</p>
            </div>
          </div>
        </section>

        {/* EDUCATION */}
        <section id="education" className="glass-compartment">
          <h2 className="section-header">Education &amp; Training</h2>
            <div className="edu-item">
              <h3>B.Sc in Economics, Mathematics &amp; Statistics</h3>
              <p className="edu-org">St. Joseph's College, Bangalore &middot; 2013 – 2016</p>
            </div>
            <div className="edu-item">
              <h3>M.Sc in Big Data Analytics</h3>
              <p className="edu-org">St. Joseph's College, Bangalore &middot; 2016 – 2018</p>
            </div>
            <div className="education-timeline">
            <div className="edu-item">
              <h3>Data Science Training</h3>
              <p className="edu-org">Cambridge University, UK</p>
              <p className="muted">Intensive two-week onsite programme focusing on machine learning and data science principles.</p>
            </div>
          </div>
        </section>

        {/* CONTACT FOOTER */}
        <footer id="contact" className="footer-section">
          <h2 className="section-header">Get In Touch</h2>
          <p className="footer-tagline">Open to interesting problems and collaborations.</p>
          <div className="contact-grid">
            <a href="mailto:27.vidhi@gmail.com" className="contact-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
              27.vidhi@gmail.com
            </a>
            <a href="https://www.linkedin.com/in/vidhi-sinha-a65348b1/" target="_blank" rel="noopener noreferrer" className="contact-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
              LinkedIn
            </a>
            <a href="https://github.com/VidhiSinha27" target="_blank" rel="noopener noreferrer" className="contact-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></svg>
              GitHub
            </a>
            <a href={Resume} download="Vidhi_Sinha_Resume.pdf" className="contact-link contact-link-accent">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download Resume
            </a>
          </div>
        </footer>

      </div>
    </div>
  );
}
